import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { DDI } from 'src/app/modules/users/_types/ddi';
import { DDIsService } from 'src/app/modules/users/_services/ddis.service';
import { DialPlansService } from '../../_services/dial-plans.service';

@Component({
    selector: 'app-ddis-detail',
    templateUrl: './ddis-detail.component.html',
    styleUrls: ['./ddis-detail.component.css'],
    standalone: false
})
export class DDIsDetailComponent implements OnInit {
  public ddi: DDI = new DDI();
  public ddiFormGroup!: RxFormGroup;
  public dialPlans: any[] = [];
  public loading = false;
  public saving = false;
  public isNew = true;

  constructor(
    private ddisService: DDIsService,
    private dialPlansService: DialPlansService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService
  ) {
    this.ddiFormGroup = this.formBuilder.formGroup<DDI>(this.ddi) as RxFormGroup;
  }

  ngOnInit() {
    this.loadDialPlans();
    const id = this.config.data?.id;
    if (id) {
      this.isNew = false;
      this.loadData(id);
    }
  }

  async loadDialPlans() {
    const response = await firstValueFrom(this.dialPlansService.all({ page: { number: 1, size: 5000 }, sort: ['name'] }));
    this.dialPlans = response.data;
  }

  async loadData(id: string) {
    this.loading = true;
    try {
      this.ddi = await firstValueFrom(this.ddisService.get(id));
      this.ddiFormGroup.patchValue(this.ddi);
    } finally {
      this.loading = false;
    }
  }

  save() {
    const valid = this.formValidationService.validateForm(this.ddiFormGroup);
    if (!valid) {
      document.getElementById('ddiForm')?.classList.add('formInvalid');
      return;
    }

    this.ddi = Object.assign(this.ddi, this.ddiFormGroup.value);
    this.saving = true;
    this.ddisService.save(this.ddi).subscribe({
      next: () => {
        this.saving = false;
        this.messageService.add({ severity: 'success', detail: 'DDI guardado correctamente' });
        this.dynamicDialogRef.close();
      },
      error: (error: any) => {
        this.saving = false;
        this.messageService.add({ severity: 'error', detail: error?.error?.errors?.[0]?.title || error?.error?.title || 'Error al guardar el DDI' });
      }
    });
  }

  cancel() {
    this.dynamicDialogRef.close();
  }
}
